
import { Vue, Component, Mixins, Emit } from 'vue-property-decorator';
import LayoutCol1 from '@/components/layout/LayoutCol1.vue';
import { fetchSpecialOffer } from '@/services/userService';
import HomeCampaignlistItem from '@/components/home/HomeCampaignlist/HomeCampaignlistItem.vue';
import $ from 'jquery';
import {Route} from 'vue-router';
import store from '@/store';
import NaviArchive from '@/components/navi/NaviArchive.vue';
import BoxSpecialofferLink from '@/components/box/BoxSpecialofferLink/BoxSpecialofferLink.vue';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeDestroy',
]);

const breadcrumbPath = [
{
    label: 'Home',
    url: '/en/',
  },
  {
    label: 'SPECIAL OFFER ',
    url: '/en/specialoffer/',
  },
];

const ITEM_MAX_LENGTH = 99;

async function getDatas(to: Route) {
  const lang = 'en';
  const res = await fetchSpecialOffer({lang});
  return res;
}

@Component({
  components: {
    LayoutCol1,
    HomeCampaignlistItem,
    NaviArchive,
    BoxSpecialofferLink,
  },
})
export default class CampaignIndex extends Vue {
  private name = 'CampaignIndex';
  private newentriesLabel = '新着記事';
  private title1 = 'CAMPAIGN';
  private title2 = 'SPECIAL CONTENTS';
  private totaleItems: number = 0;
  private length: number = ITEM_MAX_LENGTH;
  private list: PostData[] = [];

  get pageNum(): number {
    return Number(this.$route.query.p);
  }

  get companyName(): string {
    return store.getters['auth/nameEn'];
  }
  get lang(): string {
    return store.getters['auth/lang'];
  }
  get memberName(): string {
    return 'For only ' + this.companyName;
  }

  private async beforeRouteEnter(to: Route, from: Route, next: any) {
    const res = await getDatas(to);
    store.commit('breadcrumb/setPath', breadcrumbPath);
    next((vm: {
      totaleItems: number,
      list: any,
    }) => {
      // vm.totaleItems = Number(res.hits);
      vm.list = res.datas;
    });
  }

  private async beforeRouteUpdate(to: Route, from: Route, next: any) {
    const res = await getDatas(to);
    // this.totaleItems = Number(res.hits);
    this.list = res.datas;
    next();
  }

  private mounted() {
    this.$store.commit('loaded', true);
  }
}
